import React, { Suspense, memo } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';

import { ActionButton, IconStatus } from '../../../../../common';
import {
    CREATE_OPERATION,
    EXPIRED_OPERATION,
    REVERT_OPERATION,
    typeOperations,
    UNNECESSARY_OPERATION,
    listRoles, ANNUITY_PAYMENT_OVERDUE,
} from '../../../../../../helpers/data-constants';

import './operations.scss';

import UserIcon from '../../../../../../assets/icons/profile.svg';
import TimeIcon from '../../../../../../assets/icons/time.svg';
import {getUserFromLocalStorage, permissionsAccess} from '../../../../../../helpers/common';

const Operation = memo(({ dataOperation, cancelOperation, cancelNewDeal }) => {
  const { accessFeatures } = useSelector(({ user }) => user);
  let { contractId } = useParams();
  const data = { dealId: +contractId, operationId: dataOperation.id };
  const userRoles = getUserFromLocalStorage();
  let accessForAdmin = userRoles && userRoles.roles.find((i) => i === listRoles.ADMIN);
  const dealStartDate = moment(dataOperation.date).format('X');
  const today = moment().startOf('day').format('X');

  const renderButton = (type) => {
    if ( ( dealStartDate >= today 
            && type === CREATE_OPERATION) 
            || (type !== UNNECESSARY_OPERATION 
            && type !== EXPIRED_OPERATION 
            && type !== REVERT_OPERATION 
            && type !== ANNUITY_PAYMENT_OVERDUE
        ) ){
        if (permissionsAccess("action.transaction.revert")) {
          return <ActionButton
                  text="Отменить"
                  func={ 
                    type === CREATE_OPERATION 
                    ? cancelNewDeal  
                    : cancelOperation
                  } 
                  param={data} 
                />;
        } else {
          return null;
        }
    }
    return null;
  };
    const renderButtonVisem = (type) => {
        if (type !== CREATE_OPERATION && type !== EXPIRED_OPERATION && type !== REVERT_OPERATION) {
            if (permissionsAccess("action.operation.revert")) {
                return <ActionButton text="Отменить" func={cancelOperation} param={data} />;
            } else {
                return null;
            }
        }
        return null;
    };
  const View = React.lazy(() => import('./Content/' + typeOperations[dataOperation.type].view));

  return (
    <div className="contracts-timeline-item">
      <div className="contracts-timeline-item-header">
        <div className="contracts-timeline-item-header-left">
          <IconStatus
            newStatus={dataOperation.newStatus}
            previousStatus={dataOperation.previousStatus}
            status={dataOperation.type}
          />
        </div>
        <div className="contracts-timeline-item-user">
          {dataOperation.type !== typeOperations[EXPIRED_OPERATION].param ? (
            <>
              <span className="icon">
                <UserIcon />
              </span>
              {accessForAdmin
                ? <Link className="link" to={`/user/${dataOperation.userId}`}>
                    <span>{dataOperation.userFullName}</span>
                  </Link>
                :  <span>{dataOperation.userFullName}</span>
              }
            </>
          ) : null}
        </div>
        <div className="contracts-timeline-item-datetime">
          <span className="icon">
            <TimeIcon />
          </span>
          <span>{moment(dataOperation.date).format('DD.MM.YYYY, HH:mm:ss')}</span>
        </div>
      </div>
      <div className="contracts-timeline-item-content">
        <div className="contracts-timeline-item-content-left">
          <Suspense fallback={<></>}>
            <View dataOperation={dataOperation} />
          </Suspense>
        </div>
        <div className="contracts-timeline-item-content-right">
          {
              accessFeatures['deal.cancellation.reuse']
              ? renderButton(dataOperation.type)
              : renderButtonVisem(dataOperation.type)
          }
        </div>
        {permissionsAccess("action.operation.revert") && (dataOperation.type === REVERT_OPERATION) && (
          <ActionButton text="Отменить отмену" func={cancelOperation} param={data} />
        )}
      </div>
    </div>
  );
});

export default Operation;
